import React from "react";
import IATFHeader from "../../../components/Compliance Certificates/IATF 16949 2016/IATFHeader";
import IATFInfoContainer from "../../../components/Compliance Certificates/IATF 16949 2016/IATFInfoContainer";

const IATF16949 = () => {
  return (
    <div>
      <IATFHeader />
      <IATFInfoContainer />
    </div>
  );
};

export default IATF16949;
